<template>
    <div class="columns is-multiline">
        <div class="column is-full">
            <a @click="deleteFilter"><b-icon class="has-text-danger" icon="trash"></b-icon></a>
        </div>
        <div class="column is-half">
            <b-field label="Nombre" label-position="on-border">
                <b-input
                @input="updateFilter"
                v-model="filter.title">
                </b-input>
            </b-field>
        </div>
        <div class="column is-half">
            <b-field label="Opciones" label-position="on-border">
                <b-taginput
                v-model="filter.options"
                field="title"
                @add="createOption"
                @remove="removeOption"
                >
                </b-taginput>
            </b-field>
        </div>
        <div class="column is-half">
            <b-field 
            label="Categoria" 
            label-position="on-border" 
            message="Elije una si quieres que este filtro sea exclusivo para una categoria">
                <b-select expanded @input="updateFilter" v-model="filter.category">
                    <option value="">------</option>
                    <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{cat.title}}</option>
                </b-select>
            </b-field>
            
        </div>
        <div class="column is-half">
            <b-field 
            label="Subcategoria" 
            label-position="on-border"
            message="Elije una si quieres que este filtro sea exclusivo para una subcategoria">
                <b-select expanded @input="updateFilter" v-model="filter.subcategory">
                    <option value="">------</option>
                    <option v-for="sub in subcategoryOptions" :key="sub.id" :value="sub.id">{{sub.title}}</option>
                </b-select>
            </b-field>
        </div>
        <div class="column is-full">
            <hr>
        </div>
    </div>
</template>

<script>
import { getHandler, deleteHandler, debounce, patchHandler, postHandler } from '../../../../services/http'

export default {
    props:{
        filter:{
            type:Object,
            default: new Object({})
        },
        categories:{
            type:Array,
            default: new Array([])
        },
        subcategories:{
            type:Array,
            default: new Array([])
        },
        filtersDetail:{
            type:String,
            default:""
        },
        filterOptionDetail:{
            type:String,
            default:""
        },
        filterOptionListCreate:{
            type:String,
            default:""
        },
    },
    computed:{
        subcategoryOptions(){
            var subs = this.subcategories.filter((element)=>{
                console.log(element)
                return element.category == this.filter.category
            })
            return subs
        }
    },
    methods:{
        async deleteFilter(){
            var error = {resource:'notify'}
            var success = {resource:'notify'}
            var url = this.filtersDetail.replace('0000', this.filter.id)
            var response = await deleteHandler(url, {error, success})
            this.$emit('filterListUpdate')
        },
        updateFilter: debounce(
            async function(){
                var error = {resource:'toast'}
                var success = {resource:'toast'}
                var url = this.filtersDetail.replace('0000',this.filter.id)
                var response = await patchHandler(url, this.filter, {error, success})
                this.$emit('filterListUpdate')
            }, 
            700
        ),
        async createOption(option){
            var error = {resource:'toast'}
            var success = {resource:'toast'}
            var data = {title:option, cfilter:this.filter.id}
            var response = await postHandler(this.filterOptionListCreate, data, {error, success})
        },
        
        async removeOption(option){
            var error = {resource:'toast'}
            var success = {resource:'toast'}
            var url = this.filterOptionDetail.replace('0000', option.id)
            var response = await deleteHandler(url, {error, success})
        },
    }
}
</script>